import React from 'react';
import styled from 'styled-components';
import { InlineEditableTextEditor } from '../../../components/richTextEditor';
import { Color, Grid, Type } from '../../../app/StyleGuide';
import { SectionBody, sectionIcon, TimelineComponent, TipSectionContainer } from './SessionTimelineContentElements';
import { Note } from '../models/timeline';

export const NoteSectionContainer = styled(TipSectionContainer)`
  ${sectionIcon({
    color: Color.white,
    unicode: '"\\f249"',
    left: Grid._5,
  })}

  background: ${Color.Blue._50};
  border: 1px solid ${Color.Blue._60};
  position: relative;
  text-shadow: ${Type.Shadow.dark};

  p {
    color: ${Type.Color.white};
  }
`;

const RemoveNoteButton = styled.button`
  background: none;
  border: none;

  position: absolute;
  top: ${Grid._1};
  right: ${Grid._1};
  padding: ${Grid._1} ${Grid._3};
  font-size: 16px;

  :focus-visible {
    outline: 1px solid ${Color.white};
  }

  i {
    color: ${Color.white};
    text-shadow: ${Type.Shadow.dark};
  }
`;

const NoteTitle = styled(InlineEditableTextEditor)`
  font-size: ${Type.Scale._2};
  font-weight: ${Type.Weight.semibold};
  color: ${Type.Color.white};
  width: 100%;
`;

const NoteBodyEditableText = styled(InlineEditableTextEditor)`
  width: 100%;
  color: ${Type.Color.white};
  font-weight: ${Type.Weight.normal};
`;

export const NoteSection = ({
  note,
  onRemove,
  handleUpdateNote,
  customizable,
}: {
  note: Note;
  onRemove: () => void;
  handleUpdateNote: (note: Note) => void;
  customizable: boolean;
}) => (
  <TimelineComponent>
    <SectionBody>
      <NoteSectionContainer>
        {note.title && (
          <NoteTitle
            text={note.title}
            onChangeText={text => handleUpdateNote({ ...note, title: text })}
            editable={customizable}
          />
        )}
        <NoteBodyEditableText
          text={note.body}
          onChangeText={text => handleUpdateNote({ ...note, body: text })}
          allowedTags={['strong', 'em', 'u', 'ul', 'ol', 'li', 'p', 'br', 'span']}
          editable={customizable}
        />
        {onRemove && (
          <RemoveNoteButton data-qa-hook="removeNote" onClick={onRemove}>
            <i className="fas fa-times" />
          </RemoveNoteButton>
        )}
      </NoteSectionContainer>
    </SectionBody>
  </TimelineComponent>
);
